import React, { CSSProperties } from 'react'
import styled from 'styled-components'
import { CONSTS } from './_constants';
type DescriptionBoxProps = {
    className?: string,
    content?: any,
    style?: CSSProperties
}
const DescriptionBoxComponent = (props: DescriptionBoxProps) => {
    return (
        <div className={props.className} style={props.style}>
            {props.content}
        </div>
    )
}
const DescriptionBox = styled(DescriptionBoxComponent)`
    padding: 10px;
    box-sizing: border-box;
    background: rgba(177,185,199,0.1);
    border: 1px dashed ${CONSTS.colors.greyDark};
    border-radius: ${CONSTS.border.radius2};
    font-family: ${CONSTS.fonts.primary.light};
    font-size: 14px;
    color: ${CONSTS.colors.greyDarker};
`
export default DescriptionBox;